import { useCanCreateEvent } from "@circle-react/components/LiveStreams/LiveFormV3/Modal/hooks/useCanCreateEvent";
import { useShouldDisplayGoLiveFooter } from "@circle-react/components/Spaces/SidebarV2/SidebarFooter/useShouldDisplayGoLiveFooter";
import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import { useSpaceGroupsContext } from "@circle-react/contexts/spaceGroupsContext";
import { isCommunityAdmin } from "@circle-react/helpers/communityMemberHelpers";
import { canCreateSpaces } from "@circle-react/helpers/spaceGroupHelpers";
import { useCanCreatePost } from "@circle-react/hooks/posts/useCanCreatePost";

/**
 * Whether the "Create space" option is available in the mobile create menu.
 * Admins always can; other members can when at least one space group allows
 * members to create spaces.
 */
export const useCanCreateSpace = () => {
  const { currentCommunityMember, isViewOnlyMasquerading } =
    usePunditUserContext();
  const { records: spaceGroups } = useSpaceGroupsContext();

  if (isViewOnlyMasquerading) return false;
  return (
    isCommunityAdmin(currentCommunityMember) ||
    spaceGroups.some(spaceGroup => canCreateSpaces({ spaceGroup }))
  );
};

/**
 * Whether the mobile TopBar's "+" create action should show at all.
 */
export const useCanShowMobileCreateButton = () => {
  const { canCreatePost } = useCanCreatePost();
  const { canCreateEvent } = useCanCreateEvent();
  const hasGoLiveButton = useShouldDisplayGoLiveFooter();
  const canCreateSpace = useCanCreateSpace();
  return canCreatePost || canCreateEvent || hasGoLiveButton || canCreateSpace;
};
